import { dataPlayCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlayCircle = /*#__PURE__*/createIcon(dataPlayCircle)
export default IconPlayCircle
